import React, { useState } from "react";
import { Modal, Button, Icons, SearchFieldGroup } from "@texada/ui";
import i18n from "i18n/i18n";
import QuickbarHeading from "./QuickbarHeading";
import { EVENT_KEY } from "helpers/helper";
import "./Quickbar.scss";

const QuickbarHelp = props => {
  const [searchText, setSearchText] = useState("");

  return (
    <Modal
      {...props}
      header={i18n.t("help_and_feedback")}
      size="quickbar"
      shouldReturnFocusAfterClose={false}
      closeButton
    >
      <Modal.Body>
        <QuickbarHeading
          size="default"
          heading={i18n.t("help")}
          icon={{ render: Icons.Inquiry }}
        />

        <p>{i18n.t("read_our_online_documentation_on_the_texada_knowledge_center")}</p>

        <div className="quickbar-search-docs">
          <SearchFieldGroup
            placeholder={i18n.t("search_keyword")}
            onChange={e => {
              setSearchText(e.target.value);
            }}
            onClear={() => setSearchText("")}
            value={searchText}
            inputProps={{
              onKeyPress: e => {
                if (e.key === EVENT_KEY.ENTER) {
                  event.preventDefault();
                  window.open(
                    `https://help.texadasoftware.com/en/knowledge/kb-search-results?term=${searchText}`,
                    "_blank"
                  );
                }
              }
            }}
          />

          <Button
            as="a"
            buttonProps={
              searchText
                ? {
                    href: `https://help.texadasoftware.com/en/knowledge/kb-search-results?term=${searchText}`,
                    target: "_blank"
                  }
                : {}
            }
            disabled={!searchText}
          >
            {i18n.t("search")}
          </Button>
        </div>

        <Button
          as="a"
          buttonProps={{
            href: "https://help.texadasoftware.com/en/knowledge",
            target: "_blank"
          }}
        >
          {i18n.t("get_help")}
        </Button>

        <hr />

        <QuickbarHeading
          size="default"
          heading="Feedback"
          icon={{ render: Icons.Feedback }}
        />

        <p>
          {i18n.t("help_make_this_product_better_by_sharing_your_thoughts_and_ideas_with_our_product_team")}
        </p>

        <Button
          as="a"
          buttonProps={{
            href: "https://texada.ideas.aha.io/portal_session/new",
            target: "_blank"
          }}
        >
          {i18n.t("send_feedback")}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default QuickbarHelp;
